var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 76,
    viewBox: "0 0 52 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4247 37.1039L24.103 38.6363L24.6251 40.2101L24.9789 41.8135L25.151 43.4349L25.1284 45.0107L24.9145 46.4795L24.5188 47.8333L23.9495 49.0635L23.2141 50.1602L22.3193 51.1121L21.2701 51.9069L20.0714 52.5293L18.728 52.9615L17.246 53.183L15.6336 53.1712L13.9016 52.9017L12.1245 52.3698L10.3843 51.5961L8.70654 50.5975L7.11797 49.3937L5.64527 48.0081L4.31456 46.4666L3.15082 44.7975L2.17739 43.0311L1.41538 41.1989L0.883234 39.3334L0.596207 37.4667L0.566136 35.6299L0.792535 33.9092L1.24979 32.3767L1.91061 31.0375L2.74973 29.894L3.74466 28.9471L4.87555 28.1977L6.12453 27.6472L7.47487 27.2981L8.91055 27.1536L10.4161 27.2176L11.9769 27.494L13.5793 27.9871L15.1584 28.6777L16.6535 29.5306L18.0575 30.5274L19.3627 31.651L20.5609 32.8852L21.6435 34.215L22.6014 35.6258L23.4247 37.1039Z",
    fill: "#FF91ED",
    fillOpacity: 0.56,
    stroke: "url(#paint0_linear_303_16)",
    strokeWidth: 1.13106
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_303_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.765781 32.278L0.262555 33.9337L0 35.773L0.00175484 37.7195L0.266774 39.6846L0.781325 41.637L1.52911 43.5453L2.49152 45.3782L3.64794 47.1052L4.97615 48.6971L6.45268 50.1262L8.05319 51.3665L9.75293 52.3946L11.5271 53.1894L13.3511 53.7321L15.144 54.0001L16.8307 53.9961L18.397 53.7422L19.55 53.3678L20.7243 52.9865L21.9203 52.5982L23.1387 52.2025L21.567 52.4486L19.8684 52.4355L18.0567 52.1404L16.2075 51.5607L14.4032 50.7208L12.6691 49.6399L11.0309 48.3402L9.51454 46.8463L8.14522 45.1853L6.94745 43.3864L5.94445 41.4806L5.15771 39.4998L4.60666 37.477L4.30831 35.4453L4.27692 33.4374L4.51469 31.5451L4.9986 29.8468L5.70263 28.3528L6.60096 27.071L7.66853 26.0071L8.88137 25.1655L7.80187 25.8081L6.74211 26.439L5.70155 27.0585L4.67968 27.6668L3.46522 28.505L2.3921 29.5564L1.48409 30.8162L0.765781 32.278Z",
    fill: "url(#paint1_linear_303_16)",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_303_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9139 36.4064L28.2139 34.7506L27.3657 33.1559L26.3798 31.6353L25.2658 30.2026L24.0324 28.8723L22.6877 27.6601L21.239 26.5831L19.6931 25.6598L18.0566 24.9103L16.3897 24.3732L14.7571 24.0705L13.1732 24L11.6538 24.16L10.2168 24.5491L8.88129 25.1654L7.66848 26.007L6.60091 27.0709L5.70257 28.3528L4.99854 29.8468L4.51463 31.545L4.27686 33.4373L4.30825 35.4452L4.6066 37.4769L5.15764 39.4997L5.94438 41.4805L6.94738 43.3864L8.14515 45.1852L9.51448 46.8462L11.0309 48.3401L12.669 49.6399L14.4031 50.7207L16.2075 51.5606L18.0566 52.1403L19.8684 52.4354L21.567 52.4485L23.1387 52.2025L24.5716 51.7197L25.8554 51.0218L26.981 50.1289L27.9405 49.0601L28.7267 47.8323L29.3326 46.4614L29.7514 44.9612L29.9763 43.3436L29.9999 41.6189L29.8209 39.8524L29.454 38.111L28.9139 36.4064Z",
    fill: "url(#paint2_linear_303_16)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7028 34.994L28.3828 36.6024L28.9064 38.2551L29.2613 39.9395L29.434 41.6436L29.4113 43.3006L29.1965 44.8457L28.7988 46.2701L28.227 47.5639L27.489 48.7164L26.5921 49.7155L25.5423 50.5483L24.3445 51.1994L23.0037 51.6512L21.5251 51.8826L19.9163 51.8702L18.1873 51.5886L16.4123 51.0322L14.673 50.2226L12.9954 49.1769L11.4062 47.9159L9.93222 46.4639L8.59988 44.8477L7.43426 43.0972L6.45885 41.2438L5.69494 39.3205L5.16119 37.3611L4.87313 35.3995L4.84294 33.4683L5.07036 31.6584L5.52978 30.0461L6.19349 28.6376L7.03542 27.4363L8.03212 26.4431L9.16313 25.6582L10.4105 25.0825L11.758 24.7177L13.1903 24.5669L14.6926 24.6337L16.2508 24.9226L17.8514 25.4384L19.4296 26.1611L20.9244 27.054L22.3289 28.0981L23.6349 29.2754L24.8344 30.5691L25.9184 31.9634L26.8778 33.4431L27.7028 34.994Z",
    stroke: "url(#paint3_linear_303_16)",
    strokeWidth: 1.13106
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_303_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0869 30.1484C17.6636 30.2752 18.1406 30.8105 18.1698 31.3524L18.2111 32.3051C20.2745 33.1551 21.1894 34.984 21.2868 36.1639C21.3354 36.708 20.9169 37.0641 20.3524 36.9571C20.3256 36.9549 20.2989 36.9505 20.2721 36.944C19.7587 36.8369 19.2988 36.3059 19.2526 35.7946C19.2161 35.445 18.9557 34.2847 17.2962 33.9395C15.6975 33.6074 15.5516 34.5819 15.5613 35.0167C15.6002 35.3729 15.8752 36.3606 17.486 36.6927C20.2989 37.2761 21.479 39.5813 21.5861 40.9929L21.5885 41.0409L21.5861 41.0956C21.5471 41.8013 21.2649 42.411 20.7807 42.8371C20.2964 43.2631 19.6395 43.4838 18.9022 43.4642L18.9703 44.5851C19.0019 45.1248 18.5664 45.4679 18.0019 45.3499C17.4373 45.2319 16.9531 44.6987 16.9215 44.159L16.8534 43.0381C14.7778 42.1968 13.9505 40.4029 13.8118 39.459C13.7266 38.9127 14.1111 38.5238 14.6731 38.5915C14.7023 38.5959 14.7315 38.6002 14.7607 38.6068C15.2985 38.7182 15.7584 39.1858 15.8387 39.7102C15.8946 40.0162 16.2061 41.0737 17.7683 41.3971C19.3085 41.7161 19.5105 40.8028 19.5397 40.5471C19.4813 40.1298 19.1893 38.9804 17.6028 38.6505C14.7899 38.0671 13.6171 35.9017 13.5173 34.5863C13.4565 33.3823 14.1451 31.8659 16.1745 31.8746L16.1258 30.9045C16.0966 30.3713 16.5297 30.0326 17.0869 30.1484Z",
    fill: "url(#paint4_linear_303_16)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7735 30.494L16.7737 30.4939C16.7591 30.2042 16.8805 29.9734 17.082 29.8406L16.3027 30.3501C16.1012 30.4829 15.9799 30.7136 15.9943 31.0031L15.9941 31.0032L16.0427 31.9701L16.822 31.4627L16.7735 30.494Z",
    fill: "url(#paint5_linear_303_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2137 37.0353L20.2135 37.0354C20.1868 37.0332 20.1601 37.0289 20.1333 37.0224C19.6211 36.9157 19.1622 36.3865 19.1161 35.8769C19.0797 35.5285 18.8199 34.3722 17.1641 34.0282C16.5231 33.8953 16.1153 33.9737 15.8579 34.1414L16.6372 33.6318C16.8946 33.4642 17.3025 33.3858 17.9434 33.5186C19.5992 33.8605 19.859 35.0168 19.8954 35.3674C19.9415 35.8769 20.4028 36.4061 20.9127 36.5128L20.9925 36.5258L20.9927 36.5257C21.2371 36.5713 21.4574 36.5303 21.6199 36.4244L20.8422 36.9329C20.6796 37.0396 20.4588 37.0809 20.2137 37.0353Z",
    fill: "url(#paint6_linear_303_16)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3913 34.6747L13.391 34.6749C13.3497 33.8691 13.6459 32.9219 14.4592 32.3906L15.2371 31.882C14.4255 32.4131 14.1295 33.3586 14.1702 34.1634L14.1705 34.1632C14.2724 35.4741 15.4426 37.6321 18.2468 38.2136C19.8298 38.5424 20.1211 39.6878 20.1794 40.1037L19.4 40.6133C19.3418 40.1973 19.0504 39.0519 17.4675 38.7231C14.6622 38.142 13.4918 35.9858 13.3913 34.6747ZM19.752 40.8289L18.9731 41.3382C19.3126 41.116 19.3854 40.7591 19.4 40.6155L20.1793 40.1059C20.1647 40.2496 20.0919 40.6046 19.752 40.8289Z",
    fill: "url(#paint7_linear_303_16)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1527 42.5859L20.3733 43.0955C19.9266 43.3873 19.3706 43.5354 18.7637 43.5201L19.543 43.0106C20.1524 43.0258 20.7059 42.8799 21.1527 42.5859Z",
    fill: "#FF2798"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7872 44.2148L17.5666 43.7052L17.4986 42.5881L16.7192 43.0977L16.7872 44.2148ZM18.5235 45.3014L19.3028 44.7919C19.1305 44.9029 18.9022 44.9443 18.6449 44.892C18.0816 44.7745 17.5985 44.2431 17.5669 43.7053L16.7876 44.2148C16.8192 44.7527 17.3023 45.284 17.8656 45.4016C18.1229 45.456 18.3511 45.4125 18.5235 45.3014Z",
    fill: "url(#paint8_linear_303_16)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.499 42.5882L16.7197 43.0978C14.6487 42.2594 13.8233 40.4716 13.6849 39.5309C13.6339 39.202 13.7553 38.9299 13.9811 38.7818L14.7604 38.2722C14.5322 38.4203 14.4132 38.6925 14.4642 39.0213C14.6026 39.962 15.4281 41.7498 17.499 42.5882Z",
    fill: "url(#paint9_linear_303_16)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_303_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7345 29.7404C18.3099 29.8667 18.7858 30.4002 18.8149 30.9402L18.8562 31.8897C20.915 32.7368 21.8278 34.5594 21.925 35.7353C21.9735 36.2775 21.5559 36.6325 20.9927 36.5258C20.966 36.5236 20.9393 36.5192 20.9125 36.5127C20.4003 36.406 19.9414 35.8768 19.8953 35.3673C19.8589 35.0189 19.5991 33.8626 17.9433 33.5185C16.3482 33.1875 16.2025 34.1587 16.2122 34.5921C16.2511 34.947 16.5254 35.9313 18.1327 36.2623C20.9393 36.8437 22.1168 39.1411 22.2236 40.5478L22.226 40.5957L22.2236 40.6501C22.1847 41.3535 21.9031 41.961 21.42 42.3857C20.9368 42.8103 20.2813 43.0302 19.5457 43.0106L19.6136 44.1277C19.6452 44.6656 19.2106 45.0075 18.6474 44.8899C18.0841 44.7723 17.601 44.241 17.5694 43.7031L17.5014 42.586C15.4305 41.7476 14.605 39.9598 14.4666 39.0191C14.3816 38.4747 14.7652 38.0871 15.3261 38.1546C15.3552 38.159 15.3843 38.1633 15.4135 38.1699C15.95 38.2809 16.4089 38.7469 16.489 39.2695C16.5449 39.5744 16.8556 40.6284 18.4143 40.9506C19.9511 41.2686 20.1526 40.3583 20.1818 40.1036C20.1235 39.6876 19.8322 38.5422 18.2492 38.2134C15.4426 37.632 14.2724 35.474 14.1728 34.1631C14.1121 32.9632 14.7992 31.452 16.8241 31.4607L16.7755 30.4938C16.7464 29.9625 17.1785 29.625 17.7345 29.7404Z",
    fill: "url(#paint10_linear_303_16)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_303_16",
    x: -33.9318,
    y: -8.76624,
    width: 91.0022,
    height: 96.6981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.9659
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_303_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_303_16",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_303_16",
    x: -10.4269,
    y: 9.29624,
    width: 55.1306,
    height: 57.856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.35188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_303_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_303_16",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_303_16",
    x: -16.4863,
    y: 0.125732,
    width: 68.0748,
    height: 75.2474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_303_16"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_303_16",
    x: -1.42436,
    y: 14.1242,
    width: 39.2439,
    height: 46.3824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.79677
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_303_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_303_16",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_16",
    x1: 0.0238572,
    y1: 47.2527,
    x2: 11.5474,
    y2: 38.8813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688828,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_16",
    x1: 6.72966,
    y1: 29.4971,
    x2: 16.2994,
    y2: 54.5138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325325,
    stopColor: "#FFBDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59538,
    stopColor: "#FF60E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814274,
    stopColor: "#FF2EEA",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896974,
    stopColor: "#C900B5",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0060",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_16",
    x1: -2.28334,
    y1: 36.5031,
    x2: 37.5934,
    y2: 41.0685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.404167,
    stopColor: "#FF8BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "#DE76D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_16",
    x1: 1.68235,
    y1: 44.587,
    x2: 21.5486,
    y2: 48.4936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0596223,
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701218,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_303_16",
    x1: 15.1197,
    y1: 30.9967,
    x2: 16.4301,
    y2: 50.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46041,
    stopColor: "#B900A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_303_16",
    x1: 16.5376,
    y1: 29.8406,
    x2: 16.5376,
    y2: 31.9703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93F4",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23D97",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_303_16",
    x1: 17.5337,
    y1: 33.9927,
    x2: 18.1969,
    y2: 37.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544343,
    stopColor: "#BB3CAE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00E5",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_303_16",
    x1: 15.3626,
    y1: 33.3025,
    x2: 18.7611,
    y2: 41.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0486117,
    stopColor: "#FF91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372917,
    stopColor: "#E041D0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716667,
    stopColor: "#CC1EBB",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED39DB",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_303_16",
    x1: 18.011,
    y1: 42.5881,
    x2: 18.011,
    y2: 45.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00E5",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_303_16",
    x1: 15.5862,
    y1: 38.2722,
    x2: 15.6284,
    y2: 44.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E366D7",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB47CC",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_303_16",
    x1: 15.7716,
    y1: 30.5858,
    x2: 17.076,
    y2: 50.3213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46041,
    stopColor: "#FF91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#D22AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6c24f53ed5419726b18b7839bf097624.svg";
export { ForwardRef as ReactComponent };